import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import EmailDetails from './form/EmailDetails.js';
import Notification from '../../components/Notification.js';
import GeneralHandler from '../../modules/General';
import {setSetting} from '../../actions/General.js';
import ColorPicker from '../../components/builder/ColorPicker.js';

import Dropzone from 'react-dropzone';
import LoadingSmall from '../../components/LoadingSmall';
import PushTranslation from "./form/PushTranslation";
import NumberPicker from "../../components/widgets/NumberPicker";
import Switch from 'rc-switch';

class SettingsPush extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isUploading:false,
            isLoading:true,
            isSavingTranslation:false,
        }
        this.updateKey = this.updateKey.bind(this);

        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTranslationSubmit = this.handleTranslationSubmit.bind(this);
        this.saveStatus = this.saveStatus.bind(this);
        this.errors = this.errors.bind(this);
    }

    errors() {
        let errors = [];

        if(this.props.general.settings.LOGO_300x200 == '' || !this.props.general.settings.LOGO_300x200) {
            errors.push({
                'text':'You must add a 300x200 logo',
                'link':'/settings/company'
            });
        }

        if(this.props.general.settings.LOGO_64x64 == '' || !this.props.general.settings.LOGO_64x64) {
            errors.push({
                'text':'You must add a 64x64 logo',
                'link':'/settings/company'
            });
        }

        if(this.props.general.settings.SUBDOMAIN == '' || this.props.general.settings.SUBDOMAIN == null || !this.props.general.settings.SUBDOMAIN) {
            errors.push({
                'text':'You must add a subdomain',
                'link':'/settings/company'
            });
        }

        return errors;
    }

    saveStatus() {

        if(this.errors().length > 0) {
            Notification.error('Please correct missing configuration options before saving');
            return;
        }

        this.handleTranslationSubmit({
            PUSH_DELAY:this.props.general.settings.PUSH_DELAY,
            PUSH_ACTIVE:this.props.general.settings.PUSH_ACTIVE,
            PUSH_POSITION:this.props.general.settings.PUSH_POSITION,
        })
    }

    handleColorChange(key,value) {
        this.props.setSetting(key,value);
    }

    handleInputChange(e) {
        let subdomain = e.target.value;
        this.props.setSetting('SUBDOMAIN',subdomain);
    }

    handleTranslationSubmit(values) {
        this.setState({
            isSavingTranslation:true
        });

        axios.put('/settings',values).then(res => {
            this.setState({
                isSavingTranslation:false
            });

            for(let i in values) {
                this.props.setSetting(i,values[i]);
            }


            Notification.success('Success!');
        }).catch(err => {
            this.setState({
                isSavingTranslation:false
            });
        });
    }

    updateKey(key) {


        if(key == 'SUBDOMAIN') {
            let subdomain = this.props.general.settings[key];
            if(subdomain.length < 3) {
                Notification.error('Subdomain must contain more than two characters');
                return;
            }

            let reg = new RegExp(/[^0-9-A-z]/g);

            if(reg.test(subdomain)) {
                Notification.error('Subdomain can only contain A-Z and 0-9');
                return;
            }


        }

        this.setState({
            ['isSaving'+key]:true
        });

        let data = {
            [key]:this.props.general.settings[key],
        };

        axios.put('/settings',data).then(res => {
            this.setState({
                ['isSaving'+key]:false
            });

            Notification.success('Success!');
        }).catch(err => {
            this.setState({
                ['isSaving'+key]:false
            });
        });
    }

    componentWillMount() {
        GeneralHandler.fetchGeneral().then(() => {
            this.setState({isLoading:false});
        });


    }

    render() {

        if(this.state.isLoading) {
            return <Loading error={false} />
        }

        let errors = this.errors();



        return (
            <div className="full-height">
                <Helmet title="Push notifications | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-rocket"></i> Push notifications</span>
                </div>

                <div className="page-content">

                    <OptionColumn title="Status and delay" description="How long should Crall wait until asking for permission. Turn on/off push notifications">

                        {
                            errors.length > 0 ?
                                <div className="alert alert-danger alert-dismissible" role="alert">
                                    Before you can enable push notifications you must configure these options:

                                    <ul style={{paddingLeft:'30px',paddingTop:'20px',paddingBottom:'20px'}}>
                                        {errors.map((item,i) => {
                                            return <li key={i}><Link style={{color:'#f96868',fontWeight:400}} to={GeneralHandler.Link(item.link)}>{item.text}</Link></li>

                                        })}
                                    </ul>
                                    Click on each step to configure.
                                </div>:null
                        }


                        <div className="col-sm-4">
                            <h5>Status</h5>
                            <div className="col-sm-12 text-center">
                                Off &nbsp;&nbsp;
                                <Switch onChange={(val) => { this.props.setSetting('PUSH_ACTIVE',val) } }
                                        checked={(this.props.general.settings.PUSH_ACTIVE == '1' ? true:false)}
                                        checkedChildren={<i className="icon fa-check"></i>}
                                        unCheckedChildren={<i className="icon fa-close"></i>}
                                /> &nbsp;On
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <h5>Position</h5>
                            <select value={this.props.general.settings.PUSH_POSITION} onChange={(e) => { this.props.setSetting('PUSH_POSITION',e.target.value) } } className="form-control">
                                <option value="left">Left</option>
                                <option value="right">Right</option>
                            </select>
                        </div>

                        <div className="col-sm-4">
                            <h5>Delay</h5>
                            <NumberPicker min={0} max={30} value={this.props.general.settings.PUSH_DELAY} handleChange={(val) => { this.props.setSetting('PUSH_DELAY',val) } } type="seconds" />
                        </div>

                        <div className="col-sm-12 m-t-20">
                            <button type="button" onClick={this.saveStatus} className="btn btn-dark btn-block">Update</button>
                        </div>
                    </OptionColumn>

                    <SplitRows />

                    <OptionColumn title="Translations" description="Translate strings to your native language.">
                        <PushTranslation isSavingTranslation={this.state.isSavingTranslation} onSubmit={this.handleTranslationSubmit} />
                    </OptionColumn>

                    <SplitRows />



                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSetting},dispatch)
}


SettingsPush = connect(mapStateToProps,mapDispatchToProps)(SettingsPush);
export default SettingsPush;


// WEBPACK FOOTER //
// ./containers/settings/SettingsPush.js